<script lang="ts">
    import { _ } from 'svelte-i18n';
    import { canWrite, writeDisabledTooltip } from './Permissions/writeAccess';

    export let text: string = 'Click me';
    export let disabled: boolean = false;
    export let showIcon: boolean = false;
    /**
     * Opt-in: ustaw true na przyciskach, które zapisują dane. Domyślnie false, bo ButtonMain jest
     * też przyciskiem "OK" w modalach i akcją odczytową - konto z can_write = true i wszystkie
     * pozostałe użycia mają działać dokładnie jak przed wdrożeniem uprawnień.
     */
    export let requiresWrite: boolean = false;

    $: writeBlocked = requiresWrite && !$canWrite;
</script>

<!-- tooltip na obudowie, bo wyłączony <button> nie wyświetla title w części przeglądarek -->
<span class="wrapper" title={writeBlocked ? $_(writeDisabledTooltip) : ''}>
    <button class="btn-main dont-break" class:showIcon on:click disabled={disabled || writeBlocked}>
        {text}
        {#if showIcon}
            <icon></icon>
        {/if}
    </button>
</span>

<style>
    .wrapper {
        display: inline-flex;
    }
    .btn-main {
        background-color: #1c5dc7; /* var(--analytics-green); */
        color: white;
        padding: 0 12px;
        border-radius: 5px;
        border: none;
        cursor: pointer;
        font-size: 16px;
        min-width: 140px;
        min-height: 32px;
        position: relative;
    }
    .showIcon {
        padding-right: 40px;
    }
    .btn-main icon {
        background-image: url('Icons/svg/navigate_next_FILL0_wght400_GRAD0_opsz24.svg');
        background-repeat: no-repeat;
        background-position: 0px center;
        background-size: 24px;
        position: absolute;
        width: 20px;
        height: 20px;
        padding: 0 10px;
        margin: 0 10px;
        opacity: 0.6;
    }
    .btn-main[disabled] {
        background-color: var(--automapa-grey-dark);
        cursor: not-allowed;
    }
</style>
